export const SESSION_CONSTANTS = {
	MUTLI_CAMERA_MAX_PRESENTER_COUNT: 9,
	STATUS: {
		CANCELLED: -1,
		WAITING: 0,
		LIVE: 1,
		RECORDED: 2
	}
};
